import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CustomButton } from "components/CustomButton";
import { MuiTextFieldCPF } from './MuiTextFieldCPF';
import { getCpfStatus } from './functions';

export function CpfVerificationStep({
  open,
  handleClose,
  themeColor,
  defaultCpf = '',
  BasicLogin,
  messageError = '',
  handleErrorMessage
}) {
  const [cpf, setCpf] = React.useState(defaultCpf);
  const defaultColor = themeColor?.navigation?.buttons?.backgroundColor || '#000000'

  const { completo: cpfCompleto, invalido: cpfInvalido } = getCpfStatus(cpf)

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ backdropFilter: 'blur(2px)', }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 470,
          bgcolor: '#FFFFFF',
          p: '28px 25px',
          borderRadius: '12px',
          boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
          gap: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box display="flex" alignItems="center" gap="20px" justifyContent="space-between" width={'100%'}>
          <Typography variant="body1" color="#5D5D5D" fontWeight={700} fontSize="14px" letterSpacing="0.5px">
            INSIRA SEUS DADOS
          </Typography>

          <Box
            component="span"
            className='icon-ico_cancelar'
            fontSize="20px"
            color="#da3c3c"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              handleClose()
              handleErrorMessage('')
            }}
          />
        </Box>
        <MuiTextFieldCPF
          cpf={cpf}
          setCpf={(e) => {
            setCpf(e)
            handleErrorMessage('')
          }}
          themeColor={themeColor}
          error={cpfInvalido || Boolean(messageError)}
          helperText={cpfInvalido ? 'CPF inválido' : messageError}
        />

        <Box display="flex" justifyContent="center" width="100%" gap={'15px'}>
          <CustomButton
            size="sm"
            fullWidth
            variant="contained"
            style={{ maxWidth: '174px' }}
            defaultColor={defaultColor}
            disabled={!cpfCompleto || cpfInvalido || Boolean(messageError)}
            onClick={() => BasicLogin(cpf)}
          >
            Enviar
          </CustomButton>
        </Box>
      </Box>
    </Modal>
  );
}
